import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative bg-beige pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-96">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-97">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-99">
            <div className="mb-6" data-id="element-100">
              <span className="text-olive font-semibold tracking-wider uppercase text-sm mb-2 block" data-id="element-101">
                La Cocina que Vende
              </span>
              <span className="inline-block bg-olive text-beige px-3 py-1 rounded-full text-xs font-medium tracking-wide" data-id="element-102">
                Meriendas Saludables Congeladas
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-103">
              <span className="text-olive" data-id="element-104">Convertí tu cocina</span>{' '}
              <span className="text-brown-dark" data-id="element-105">en un negocio</span>{' '}
              <span className="text-olive" data-id="element-106">y empezá a vender</span>{' '}
              <span className="text-brown-dark" data-id="element-107">meriendas congeladas</span>
            </h1>

            <p className="text-lg md:text-xl text-brown mb-8 leading-relaxed" data-id="element-108">
              Aprendé a producir, freezar y vender con recetas probadas, costos
              claros y un sistema simple para generar ingresos desde tu casa.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-8" data-id="element-109">
              <div className="flex items-center text-brown-dark font-medium" data-id="element-110">
                <svg className="w-5 h-5 text-olive mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-111">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-112"></path>
                </svg>
                Sin experiencia
              </div>
              <div className="flex items-center text-brown-dark font-medium" data-id="element-113">
                <svg className="w-5 h-5 text-olive mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-114">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-115"></path>
                </svg>
                Sin local
              </div>
              <div className="flex items-center text-brown-dark font-medium" data-id="element-116">
                <svg className="w-5 h-5 text-olive mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-117">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-118"></path>
                </svg>
                Sin complicaciones
              </div>
            </div>

            <motion.a whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} href="https://lacocinaquevende.shop/cart/53476221124881:1" className="inline-block w-full sm:w-auto text-center bg-gold hover:bg-gold-hover text-brown-dark font-bold text-lg py-4 px-8 rounded-full shadow-lg transition-colors duration-300" data-id="element-119">
              👉 COMPRAR AHORA
            </motion.a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-120">
            <div className="absolute inset-0 bg-olive/10 rounded-3xl transform rotate-3 scale-105" data-id="element-121"></div>
            <img src="https://cdn.magicpatterns.com/uploads/xt6GJu6Hx5oBE7vEVi2Z8P/ChatGPT_Image_29_abr_2026,_08_35_45_p.m..png" alt="Meriendas congeladas empaquetadas" className="relative z-10 rounded-3xl shadow-2xl object-cover w-full h-auto" data-id="element-122" />

            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl z-20 flex items-center gap-3" data-id="element-123">
              <div className="bg-green-100 p-2 rounded-full" data-id="element-124">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-125">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-126"></path>
                </svg>
              </div>
              <div data-id="element-127">
                <p className="text-xs text-gray-500 font-medium" data-id="element-128">
                  Ingresos extra
                </p>
                <p className="text-sm font-bold text-brown-dark" data-id="element-129">
                  Desde tu casa
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative SVG Divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-130">
        <svg className="relative block w-full h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-131">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,112.36,197.4,98.7,239.5,90.06,281.4,73.1,321.39,56.44Z" fill="#ffffff" data-id="element-132"></path>
        </svg>
      </div>
    </section>;
}